var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgSvgDogForbidden = function SvgSvgDogForbidden(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#a)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M12 23.5c6.351 0 11.5-5.149 11.5-11.5S18.351.5 12 .5.5 5.649.5 12 5.649 23.5 12 23.5Z",
    fill: "#66E1FF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m12 20.04-1.02 3.41a11.412 11.412 0 0 1-7.64-3.89l1.37-3.19L12 20.04Z",
    fill: "#FF808C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M23.5 12A11.49 11.49 0 0 0 3.728 4.023l16.249 16.249A11.454 11.454 0 0 0 23.5 12Z",
    fill: "#C2F3FF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.5 12.85c0 3-2.25 2.96-5.09 3.6l-1.39.15L12 20.04l-7.29-3.67 2.08-4.83c.17-1.74 1.48-5.79 3.64-7.11a.482.482 0 0 1 .42-.05.522.522 0 0 1 .31.29l1.55 3.97 3.98.87a3.382 3.382 0 0 1 2.81 3.34Z",
    fill: "#FFBC44"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m16.688 9.51-3.98-.87-1.55-3.97a.52.52 0 0 0-.526-.314.482.482 0 0 0-.204.074 7.841 7.841 0 0 0-2.664 3.629l8.093 8.093c2.119-.424 3.641-.836 3.641-3.3a3.38 3.38 0 0 0-2.81-3.342Z",
    fill: "#FFDDA1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m14.413 16.447-1.392.157-2.055 6.85M9 5.818a5.2 5.2 0 0 1 1.43-1.392.5.5 0 0 1 .727.245l1.555 3.973 3.982.868a3.386 3.386 0 0 1 2.806 3.336 2.916 2.916 0 0 1-.7 2.139M3.338 19.563l3.454-8.021c.06-.531.163-1.056.308-1.571M12 20.035l-7.287-3.664M19.977 20.272 3.728 4.023",
    stroke: "#191919",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12 23.5c6.351 0 11.5-5.149 11.5-11.5S18.351.5 12 .5.5 5.649.5 12 5.649 23.5 12 23.5Z",
    stroke: "#191919",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "a"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M0 0h24v24H0z"
  })))));
};
export default SvgSvgDogForbidden;